import { Iframe, IframeModal } from "@edp-pages/iframe/iframe.model";

export interface IIframeState {
    iframe: Iframe;
    iframeModal: IframeModal;
}

export const initialIframeState: IIframeState = {
    iframe: {
        route: null,
        preload: false,
        reload: false
    },
    iframeModal: null
};
